import { Config } from '@core/services/core/analytics/analytics-initializer';
import { environment } from 'src/environments/environment';

export const configuration: Config = {
  debug: environment.production
    ? []
    : ['click', 'screenview'],
  labelOverride: new Map([
    ['ION-BACK-BUTTON', 'Atras'],
    ['ION-MENU-BUTTON', 'Menu']
  ]),
  action: new Map([
    ['IMG', 'IMAGE'],
    ['BUTTON', 'BUTTON'],
    ['ION-BUTTON', 'BUTTON'],
    ['ION-ITEM', 'BUTTON'],
    ['ION-SEGMENT-BUTTON', 'BUTTON'],
    ['MAT-EXPANSION-PANEL-HEADER', 'BUTTON'],
    ['ION-MENU-BUTTON', 'BUTTON'],
    ['ION-BACK-BUTTON', 'ICON'],
    ['ION-SLIDE', 'BUTTON'],
    ['A', 'LINK']
  ]),
  category: new Map([
    ['ION-HEADER', 'HEADER'],
    ['MAPFRE-HEADER', 'HEADER'],
    ['ION-CONTENT', 'CONTENT'],
    ['ION-FOOTER', 'FOOTER'],
    ['MAPFRE-FOOTER', 'FOOTER'],
    ['ION-MENU', 'MENU'],
    ['MENU', 'MENU'],
    ['BODY', 'BODY'],
    ['DEFAULT', 'BODY'],
    ['MAPFRE-SEARCH-BAR', 'SEARCH ENGINE']
  ]),
  pageType: [
    ['/login', 'process'],
    ['/collective-life', 'process'],
    ['/client-area', 'process'],
    ['/inbox', 'private area'],
    ['/inbox/[A-Za-z0-9]', 'private area'],
    ['/payment-plan', 'private area'],
    ['/profile', 'private area'],
    ['/road-assistance', 'private area'],
    ['/families', 'private area'],
    ['/tecuidamos', 'private area'],
    ['/superbonus', 'private area'],
    ['/locator', 'process'],
    ['/patrimonial-sinister', 'process'],
    ['/car-sinister', 'process'],
    ['/car-sinister-without-contrary', 'process'],
    ['/car-sinister-repair', 'process'],
    ['/vehicle-accidents', 'process'],
    ['/receipt-payment', 'process'],
    ['/misc', 'other'],
    ['/operations', 'other'],
    ['/help', 'faqs'],
    ['/pwa-patrimonials', 'process'],
    ['/update-doc', 'process'],
    ['/pension-plan-valuation', 'process'],
    ['/businesses/register', 'process'],
    ['/businesses/forget', 'process'],
    ['multimap', 'process'],
  ]
};
